import { requireStates } from "util";
import { ConnectComponent2 } from "util";
import View from "./batch.view";
import Presenter from "./batch.presenter";

const initialStates = [
  {
    name: "app.registration.product.batch",
    url: "/importacao-em-lotes",
    views: {
      "content@app": ConnectComponent2(View, Presenter)
    }
  }
];

const context = require.context("./", true, /\.\/[^/]+\/index\.jsx?$/);
const states = requireStates(context, initialStates);

export { states };



// WEBPACK FOOTER //
// ./src/components/app/registration/product/batch/index.js